import { Pipe, PipeTransform, inject } from '@angular/core'
import { I18nService } from '@wm-front/core'

@Pipe({
  name: 'bigNumbers',
  standalone: true,
})
export class BigNumbersPipe implements PipeTransform {
  public i18nService = inject(I18nService)

  public transform(number: number): string {
    if (!number || isNaN(number)) {
      return '0'
    }

    if (number < 100000 && number > -100000) {
      return this.i18nService.formatNumber(number)
    }

    let abs = Math.abs(number)
    const rounder = Math.pow(10, 1)
    const isNegative = number < 0 // will also work for Negetive numbers
    let key = ''

    const power = { key: 'K', value: 1000 }

    let reduced = abs / power.value
    reduced = Math.round(reduced * rounder) / rounder

    if (reduced >= 1) {
      abs = reduced
      key = power.key
    }

    return (isNegative ? '-' : '') + abs.toString().replace('.', ',') + key
  }
}
